// Import flag SVG assets
import flagCG from '../assets/images/flags/flag-cg.svg';
import flagEU from '../assets/images/flags/flag-eu.svg';
import flagMX from '../assets/images/flags/flag-mx.svg';
import flagUS from '../assets/images/flags/flag-us.svg';
import flagWW from '../assets/images/flags/flag-ww.svg';

export enum CurrencyType {
  USD = 1,
  CAD = 2,
  MXN = 3,
  EUR = 4,
}

export const currencyFlagSvgMap: Record<CurrencyType, string> = {
  [CurrencyType.USD]: flagUS,
  [CurrencyType.CAD]: flagCG,
  [CurrencyType.MXN]: flagMX,
  [CurrencyType.EUR]: flagEU,
};

export const fallbackCurrencyFlagSvg = flagWW;
